<!-- 官方入口 -->
<template>
  <div :class="$style.community">
    <lazy-component>
      <ul v-if="dataSource.length > 0" :class="$style['community-wrap']">
        <li v-for="(el, index) in dataSource" :key="index">
          <a
            :href="el.url || 'javascript:void(0);'"
            :target="el.url && '_blank'"
            @click="onClick(el)"
          >
            <img :src="el.icon" />
          </a>
        </li>
      </ul>
      <van-popup
        v-model="visible"
        get-container="body"
        style="background-color: transparent; overflow: visible"
      >
        <div :class="$style['community-qrc']">
          <img v-if="qrcImg" :src="qrcImg" />
          <p v-if="qrcText">{{ qrcText }}</p>
        </div>
      </van-popup>
    </lazy-component>
  </div>
</template>

<script>
export default {
  name: 'TheCommunity',
  props: {
    dataSource: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      visible: false,
      qrcImg: '',
      qrcText: ''
    }
  },
  methods: {
    onClick(el) {
      if (el.url) return
      if (el.qrc) this.qrcImg = el.qrc
      this.qrcText = el.qrc_tip || ''
      this.visible = true
    }
  }
}
</script>

<style lang="less" module>
.community {
  .background-fill('./images/community-bg.jpg');

  height: 8.15rem;
  margin-top: -0.01rem;
  padding-top: 4.63rem;

  &-wrap {
    display: flex;
    justify-content: center;
    gap: 0.64rem;

    li img {
      .size(1.5rem, 1.83rem);
    }
  }

  &-qrc {
    background-color: #fff;
    border-radius: 0.2rem;
    padding: 0.2rem;
    text-align: center;

    img {
      .size(2rem);
    }

    p {
      font-size: 0.2rem;
      color: #333;
      margin-top: 0.1rem;
    }
  }
}
</style>
